import { Alert, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { stockTakeApi } from '@/features/stock-takes/api/stock-take-api';

export function StockTakeLockBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: active = [] } = useQuery({
    queryKey: ['stock-takes-active'],
    queryFn: stockTakeApi.listActive,
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
  });

  if (active.length === 0) return null;

  return (
    <Alert
      type="warning"
      showIcon
      banner
      message={
        <Space wrap>
          <span>{t('stock_take.banner.warehouse_locked')}</span>
          {active.map((st) => (
            <a key={st.id} onClick={() => navigate(`/stock-takes/${st.id}/${st.status === 'OPEN' ? 'scan' : 'review'}`)}>
              [{st.warehouseName} — #{st.id} {t(`stock_take.status.${st.status}`)}]
            </a>
          ))}
          <span style={{ color: '#888', fontSize: 12 }}>
            {t('stock_take.banner.hint')}
          </span>
        </Space>
      }
    />
  );
}
